import { useSelector, useDispatch } from '../actions/types';
import { Actions as SearchActions } from '../actions/search';
export default function useSearchResults() {
    const dispatch = useDispatch();
    const results = useSelector((state) => state.search.results);
    const searchTerm = useSelector((state) => state.search.searchedTerm);
    const isFetching = useSelector((state) => state.search.isFetching);
    const totalCount = useSelector((state) => state.search.totalCount);
    const currentPage = useSelector((state) => state.search.currentPage);
    const totalPages = useSelector((state) => state.search.totalPages);
    const hasMore = currentPage && totalPages ? currentPage < totalPages : false;
    const loadMore = () => {
        if (!currentPage || !searchTerm || !hasMore)
            return;
        dispatch(SearchActions.searchRequest({ query: searchTerm, page: currentPage + 1 }));
    };
    const clearResults = () => dispatch(SearchActions.searchReset());
    return {
        isFetching,
        searchTerm,
        hasMore,
        results,
        loadMore,
        totalCount,
        clearResults,
    };
}
//# sourceMappingURL=useSearchResults.js.map